<script>
import { Calendar } from '@fullcalendar/core';
import timeGridPlugin from '@fullcalendar/timegrid'
import bootstrap5Plugin from '@fullcalendar/bootstrap5';
import nlLocale from '@fullcalendar/core/locales/nl';
import interactionPlugin from '@fullcalendar/interaction'
import CalendarMixin from '@/pages/appointments/mixins/calendar';

export default {
  mixins: [CalendarMixin],
  props: {
      userId: {
        default: null
      }
  },
  mounted() {
    this.initialiseCalendar();
  },
  methods: {
    refresh() {
      let calendar = $(this.$refs.calendar).data('calendar');
      calendar.render();
    },

    initialiseCalendar() {
      let calendar = new Calendar(this.$refs.calendar, {
        plugins: [timeGridPlugin, bootstrap5Plugin, interactionPlugin],
        initialView: 'timeGrid',
        editable: this.$page.props.auth.permissions.includes('manage appointments'),
        themeSystem: 'bootstrap5',
        locale: nlLocale,
        allDaySlot: false,
        events: this.getEvents.bind(this)
      });

      calendar.render();

      $(this.$refs.calendar).data('calendar', calendar);

      this._addEventListeners(calendar);
    },

    getEvents(info, successCallback) {
      if(!this.userId) {
        successCallback([]);
        return;
      }

      $.ajax({
        url: route('api.v1.appointments.events'),
        data: {
          start: info.startStr,
          end: info.endStr,
          user_id: this.userId
        },
        success: response => successCallback(response)
      });
    }
  }
}
</script>

<template>
  <div ref="calendar"></div>
</template>